import { render } from "./Sv045.vue?vue&type=template&id=22af8661&scoped=true"
import script from "./Sv045.vue?vue&type=script&lang=js"
export * from "./Sv045.vue?vue&type=script&lang=js"

import "./Sv045.vue?vue&type=style&index=0&id=22af8661&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22af8661"]])

export default __exports__